import { DeviceInfoInterface, DeviceInfoCustomFlags } from '../deviceInfoTypes';

export function generateCustomFlags(DI: DeviceInfoInterface): DeviceInfoCustomFlags {
  return {
    /**
     * Add your custom flags here and make sure to update DeviceInfoCustomFlags.
     */
    IS_IOS_CHROME: DI.platform.IS_IOS && DI.browser.IS_CHROME,
  };
}
